export const LOCAL_ID_SYSTEM = 'local/patient-id';
export const AMMS_PATIENT_ID_SYSTEM = 'amms/patient-id';
export const AMMS_ALTERNATE_ID_SYSTEM = 'amms/alternate-id';
//# sourceMappingURL=constants.js.map